<template>
  <div class='footer-app-component'>
    <div class='footer-container'>
      <a class='footer-mail' href='mailto:hello@latelier.co'>
        <img class='footer-icon' src='@/assets/mail.svg'/>
        <span>hello@latelier.co</span>
      </a>
      <a class='footer-pin' href='https://www.google.com/maps/search/?api=1&query=46+Rue+de+l%27Arbre+Sec,+75001+Paris' target='_blank' rel='noopener'>
        <img class='footer-icon' src='@/assets/pin.svg'/>
        <span>46 Rue de l'Arbre Sec, 75001 Paris</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterAppComponent'
}
</script>

<style lang='scss' scoped>
.footer-app-component {
  background-color: #3A3635;
  border-top: 2px solid rgba(135,135,135,0.5);

  color: #FFFF;
  font-size: 0.8rem;
  font-weight: 600;

  z-index: 100;

  @include media(phone) {
    padding: 12px 0 12px 0;
  }
}

.footer-container {
  display: flex;
  flex-direction: row;

  height: 48px;

  align-items: center;
  justify-content: center;

  letter-spacing: 0.01px;

  @include media(phone) {
    flex-direction: column;

    height: auto;
  }
}

.footer-item {
  display: flex;
  align-items: center;

  height: 24px;

  margin-right: 30px;
  font-weight: 300;

  color: inherit;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    text-decoration: underline;
    opacity: 0.9;
  }

  @include media(phone) {
    margin-top: 14px;
    margin-right: unset;

    &:first-child { margin-top: 0; }
  }

  .footer-icon {
    height: 21px;
    width: 21px;

    padding-right: 8px;
  }
}

.footer-mail {
  @extend .footer-item;
}

.footer-pin {
  @extend .footer-item;
  margin-right: 0;

  @include media(phone) {
    margin-top: 4px;
  }
}

.footer-logo {
  height: 53.05px;
  width: 53.05px;
}
</style>
